import { useEffect, useState } from 'react'

import truncateText from 'util/truncateText'
import Alert from '../Alert'

type AdditionalInfoProps = {
  title: string
  text: string
  action?: () => void
  buttonName?: string
  stringsLimit?: number
}

const AdditionalInfo = ({ title, text, action, buttonName = 'Read more', stringsLimit = 5 }: AdditionalInfoProps) => {
  const [truncatedText, setTruncatedText] = useState()
  const [elementId] = useState(() => `id${Date.now().toString(36)}`)

  useEffect(() => {
    setTruncatedText(truncateText({ text, el: `#${elementId}`, stringsLimit }))
  }, [text])

  return (
    <Alert type="info" title={title} buttonText={buttonName} onClick={action}>
      <div id={elementId}>{truncatedText}</div>
    </Alert>
  )
}

export default AdditionalInfo
